import { inject } from 'vue'
import { PebbleToastsInjectionKey } from '@/plugins/pebble-toasts-plugin'

export const usePebbleToasts = () => {
    return inject(PebbleToastsInjectionKey)
}
